const STORAGE_KEY = 'modulos_sistema';

/**
 * Guarda el array de módulos del sistema en localStorage.
 * Llamado por DashboardLayout al iniciar sesión.
 */
export function setModulosSistema(modulos) {
  if (!Array.isArray(modulos)) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(modulos));
}

/**
 * Elimina los módulos del sistema del localStorage.
 * Llamado al hacer logout.
 */
export function clearModulosSistema() {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Retorna true si el módulo indicado está habilitado.
 * @param {string} clave - e.g. 'integracion_contifico', 'modulo_rrhh'
 */
export function isModuloHabilitado(clave) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const modulos = JSON.parse(raw);
    const modulo = modulos.find(m => m.clave === clave);
    return modulo ? !!modulo.habilitado : false;
  } catch {
    return false;
  }
}
